export default function initHeaderVideo() {
  Alpine.data('headerVideo', () => ({
    isPlaying: false,
    pause: false,
    video: null as HTMLVideoElement|null,

    init() {
      this.pause = localStorage.getItem('pauseVideo') === 'true';
      this.video = this.$refs.video as HTMLVideoElement|null;
      const image = this.$refs.headerImage;
      const playVideo = () => {
        if (this.video) {
          this.video.classList.remove('hidden');
          this.video.play().then(() => {
            this.isPlaying = true;
            image?.classList.add('hidden')
            this.$refs.playButton?.classList.add('hidden');
            this.$refs.stopButton?.classList.remove('hidden');
          });
        }
      }
      if (this.video !== null && !this.pause) {
        this.video.addEventListener('loadeddata', () => {
          if (!this.isPlaying && this.video && this.video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
            playVideo();
          }
        })
      }
      if (!this.pause && this.video && this.video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
        playVideo();
      }
    },

    toggleVideo() {
      if (this.video) {
        if (this.isPlaying) {
          this.video.pause();
          localStorage.setItem('pauseVideo', 'true');
          this.$refs.playButton?.classList.remove('hidden');
          this.$refs.stopButton?.classList.add('hidden');
          this.isPlaying = false;
        } else {
          this.video.play().then(() => {
            const image = this.$refs.headerImage;
            this.video?.classList.remove('hidden');
            image.classList.add('hidden');
            this.$refs.playButton?.classList.add('hidden');
            this.$refs.stopButton?.classList.remove('hidden');
            localStorage.setItem('pauseVideo', 'false');
            this.isPlaying = true;
          });
        }
      }
    }
  }))
}